<template>
  <div class="input-field-answer">
    <p class="user-answer" :class="correctnessClassname">
      <NumberInputField
        ref="numberInputField"
        class="input-field-answer-input-field"
        :disabled="lockAnswer"
        v-model="userAnswer"
      />
      <span
        v-if="unitText"
        class="input-field-answer-unit"
        v-html="unitText"
      ></span>
      <TextToSpeech :text="userAnswerTtsText" />
      <FaIcon
        v-if="canEvaluate"
        :icon="correctAnswer ? 'check' : 'times'"
        class="evaluation-icon"
      />
    </p>

    <p class="question-answer correct" v-if="canEvaluate && !correctAnswer">
      <input
        class="input-field-answer-input-field"
        type="text"
        inputmode="decimal"
        :value="answer.answer"
        disabled
      />
      <span
        v-if="unitText"
        class="input-field-answer-unit"
        v-html="unitText"
      ></span>
      <TextToSpeech :text="questionAnswerTtsText" />
      <FaIcon icon="check" class="evaluation-icon" />
    </p>
  </div>
</template>

<script>
import BaseAnswer from './BaseAnswer'

import { removeTag } from '../../utils/string'

import FaIcon from '../ui/FaIcon'
import NumberInputField from '../ui/NumberInputField'
import TextToSpeech from '../accessibility/TextToSpeech'

export default {
  name: 'InputFieldAnswer',
  extends: BaseAnswer,
  components: { NumberInputField, FaIcon, TextToSpeech },
  data() {
    try {
      // Preset the user answer if it exists
      return {
        userAnswer: this.data.UserAnswerInputField.answer,
      }
    } catch (err) {
      return {}
    }
  },
  computed: {
    answer() {
      return this.data.Answer
    },
    unitText() {
      // Remove <p> tags since we're wrapping with a <p> tag of our own.
      return this.answer.unit ? removeTag(this.answer.unit, 'p') : ''
    },
    userAnswerTtsText() {
      if (this.hasUserAnswer) {
        return `${this.userAnswer} ${this.unitText}`
      } else {
        return this.unitText
      }
    },
    questionAnswerTtsText() {
      if (this.canEvaluate) {
        return `${this.answer['answer']} ${this.unitText}`
      } else {
        return this.unitText
      }
    },
    correctnessClassname() {
      if (!this.canEvaluate) {
        return ''
      }

      return this.correctAnswer ? 'correct' : 'wrong'
    },
    canEvaluate() {
      return this.answer['answer'] !== undefined
    },
    correctAnswer() {
      return this.canEvaluate && this.isCorrect
    },
  },
  methods: {
    focus() {
      this.$refs.numberInputField.focus()
    },
    blur() {
      this.$refs.numberInputField.blur()
    },
  },
}
</script>

<style lang="scss" scoped>
.input-field-answer {
  .evaluation-icon {
    --fa-icon-size: 2em;
    vertical-align: middle;
  }

  > .wrong .evaluation-icon {
    color: $errorText;
  }

  > .correct .evaluation-icon {
    color: $successText;
  }
}

.input-field-answer-input-field {
  font-size: 2em;
  line-height: 1.5em;
  text-align: center;
  font-family: Chewy, Schoolbell, Comic Sans, sans-serif;
  width: 5em;
  border: none;
  color: inherit;
  border-bottom: 0.1em solid currentColor;
  outline: 0;
  border-radius: 0;
  vertical-align: middle;

  &:focus {
    // Remove the box shadow added by the global Fessor style
    box-shadow: none;
  }

  &:not(.invalid-keystroke) {
    background: transparent !important; // Override native style.
  }
}

.input-field-answer-unit {
  font-weight: $fontWeightMedium;
}
</style>
